import { FC, memo } from 'react';
import { EdnaWrapper } from '@providers/EdnaProvider';
import styled, { css } from 'styled-components';

import Select from '@components/Select';
import FlagIcon from '../FlagIcon';
import { FlagListType } from '../Icon/constants';

import { SelectMarketplaceProps } from './types';

const Marketplace = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

const SelectComponent = styled(Select)<{ $iconOnly: boolean; width?: string }>`
  ${(props: { $iconOnly: boolean; width?: string }) =>
    props.$iconOnly &&
    css`
      // Dropdown trigger
      [role='combobox'] {
        width: 64px !important;
      }
      [role='listbox'] {
        width: ${props.width} !important;
      }
    `}
`;

const SelectMarketplace: FC<SelectMarketplaceProps> = ({
  marketplaces = [],
  selectedMarketplace,
  placeholder,
  onMarketplaceChange,
  iconOnly = false,
  width = '230px',
  className,
  disabled = false,
  label,
  id,
}) => {
  const renderMarketplaceItems = () => {
    return marketplaces.map((m) => {
      return (
        <Select.Item value={m.code} key={m.code}>
          <Marketplace>
            <FlagIcon country={m.code as FlagListType} size="16px" />
            {m.name}
          </Marketplace>
        </Select.Item>
      );
    });
  };

  return (
    <EdnaWrapper>
      <SelectComponent
        placeholder={placeholder}
        width={width}
        onValueChange={onMarketplaceChange}
        value={selectedMarketplace}
        className={className}
        disabled={disabled}
        ariaLabel={label || 'Select Marketplace'}
        label={label}
        id={id}
        $iconOnly={iconOnly}
      >
        {renderMarketplaceItems()}
      </SelectComponent>
    </EdnaWrapper>
  );
};

SelectMarketplace.displayName = 'SelectMarketplace';

// Export for Storybook-Only, not exposed elsewhere. Memoized components can't show descriptions or default values.
export { SelectMarketplace };

export default memo(SelectMarketplace);
